import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Check, Send } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const inputCls =
  "w-full bg-surface border border-line text-ink placeholder:text-faint rounded-lg px-4 py-3.5 text-sm outline-none focus:border-brand focus:ring-1 focus:ring-brand transition-colors";

const EMPTY = { name: "", email: "", phone: "", message: "" };

export const InquiryForm = ({ vehicle, type = "kontakt", defaultMessage = "", onDone, testId = "inquiry" }) => {
  const [f, setF] = useState({ ...EMPTY, message: defaultMessage });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.email.trim() && !f.phone.trim()) {
      toast.error("Bitte E-Mail oder Telefonnummer angeben.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/leads", {
        type, name: f.name, email: f.email, phone: f.phone, message: f.message,
        vehicle_id: vehicle?.id,
      });
      setSent(true);
      toast.success("Anfrage gesendet – wir melden uns umgehend.");
      onDone?.();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Anfrage konnte nicht gesendet werden.");
    }
    setLoading(false);
  };

  if (sent)
    return (
      <div data-testid={`${testId}-success`} className="rounded-xl border border-line bg-elevated/60 p-8 text-center">
        <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-brand text-brand-ink mb-4"><Check size={22} /></span>
        <p className="font-display font-bold text-lg text-ink">Vielen Dank für Ihre Anfrage!</p>
        <p className="text-sm text-dim mt-1.5">Wir melden uns schnellstmöglich bei Ihnen.</p>
      </div>
    );

  return (
    <form onSubmit={submit} className="space-y-3.5" data-testid={`${testId}-form`}>
      <input data-testid={`${testId}-name-input`} required placeholder="Name *" value={f.name} onChange={set("name")} className={inputCls} />
      <div className="grid sm:grid-cols-2 gap-3.5">
        <input data-testid={`${testId}-email-input`} type="email" placeholder="E-Mail" value={f.email} onChange={set("email")} className={inputCls} />
        <input data-testid={`${testId}-phone-input`} placeholder="Telefon" value={f.phone} onChange={set("phone")} className={inputCls} />
      </div>
      <textarea data-testid={`${testId}-message-input`} rows={4} placeholder="Ihre Nachricht" value={f.message} onChange={set("message")} className={`${inputCls} resize-none`} />
      <p className="text-[11px] text-faint">
        E-Mail oder Telefon genügt. Ihre Daten verwenden wir ausschließlich zur Bearbeitung Ihrer Anfrage – mehr in der{" "}
        <Link to="/datenschutz" className="underline hover:text-ink" data-testid={`${testId}-privacy-link`}>Datenschutzerklärung</Link>.
      </p>
      <button data-testid={`${testId}-submit-btn`} type="submit" disabled={loading}
        className="btn-pill w-full inline-flex items-center justify-center gap-2 bg-action text-action-ink hover:bg-action-hover font-semibold py-4 text-sm disabled:opacity-50">
        <Send size={15} /> {loading ? "Wird gesendet…" : "Anfrage senden"}
      </button>
    </form>
  );
};

export default InquiryForm;
